/*
Copyright (c) 2012-2024 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
/** @jsx jsx */
import { jsx, css } from "@emotion/core"
import { FC, ReactElement, ReactNode } from "react"
import { Row, Col } from "@duxton-web/ui"
import { ChevronLeftUniversal } from "@duxton-web/icons"
import { Link } from "react-router-dom"
import { MenuButton, OverflowTip } from "./common"

export interface IMenuHeader {
  title: string
  backLink?: string
  menuButtonOverlay?: ReactElement
  content?: ReactNode
  menuVisibleChangeFunc?: (visible: boolean) => void
}

export const MenuHeader: FC<IMenuHeader> = ({
  title,
  backLink,
  menuButtonOverlay,
  content,
  menuVisibleChangeFunc,
}: IMenuHeader) => {
  return (
    <Row
      css={css`
        padding: 32px 32px 0 32px;
        align-items: center;
      `}
    >
      <Col span={24}>
        <Row gutter={8}>
          <Col>
            {backLink ? (
              <Link to={backLink}>
                <Row align="middle" gutter={20}>
                  <Col style={{ padding: 0 }}>
                    <ChevronLeftUniversal
                      style={{ color: "#000000", fontSize: 32 }}
                    />
                  </Col>
                  <Col>
                    <h1
                      className="page-title"
                      css={css`
                        max-width: 50vw;
                      `}
                    >
                      <OverflowTip>{title}</OverflowTip>
                    </h1>
                  </Col>
                </Row>
              </Link>
            ) : (
              <h1 className="page-title">
                <OverflowTip
                  css={css`
                    max-width: 800px;
                  `}
                >
                  {title}
                </OverflowTip>
              </h1>
            )}
          </Col>
          {menuButtonOverlay && title && (
            <Col>
              <MenuButton
                size="large"
                overlay={menuButtonOverlay}
                onMenuVisibleChange={menuVisibleChangeFunc}
              />
            </Col>
          )}
        </Row>
        {content && title && (
          <div
            css={css`
              margin-top: 10px;
            `}
          >
            {content}
          </div>
        )}
      </Col>
    </Row>
  )
}
